import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isAdmin } from 'shared/domain/role/isAdmin';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { WorkflowEditorPage } from 'views/projects/workflowConfiguration';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableWorkflowEditor = React.memo(
  function AuthorizableWorkflowEditor(): React.ReactElement {
    const role = useCurrentUserRole();
    const isCurrentUserAdmin = isAdmin(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={WorkflowEditorPage}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
